var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2003,
    cy: 12.2199,
    r: 11.7003,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5147 17.7193C15.0354 17.7193 14.3623 17.5459 13.3542 16.9827C12.1284 16.2953 11.1802 15.6607 9.96103 14.4447C8.78554 13.2699 8.21351 12.5093 7.4129 11.0525C6.50845 9.40757 6.66263 8.54534 6.83498 8.17683C7.04022 7.73639 7.34318 7.47296 7.73476 7.21149C7.95718 7.06577 8.19256 6.94085 8.4379 6.83832C8.46245 6.82776 8.48528 6.8177 8.50566 6.80861C8.62719 6.75386 8.81132 6.67113 9.04455 6.75951C9.2002 6.81794 9.33916 6.9375 9.55668 7.15232C10.0028 7.59228 10.6124 8.5721 10.8373 9.0533C10.9882 9.37761 11.0882 9.5917 11.0884 9.8318C11.0884 10.1129 10.947 10.3297 10.7754 10.5637C10.7432 10.6076 10.7113 10.6496 10.6804 10.6903C10.4935 10.9359 10.4525 11.0068 10.4795 11.1335C10.5343 11.3881 10.9426 12.146 11.6136 12.8155C12.2845 13.485 13.0206 13.8675 13.2761 13.922C13.4082 13.9502 13.4806 13.9075 13.734 13.714C13.7703 13.6863 13.8077 13.6576 13.8467 13.6288C14.1084 13.4341 14.3151 13.2964 14.5896 13.2964H14.5911C14.83 13.2964 15.0345 13.4 15.3733 13.5709C15.8152 13.7938 16.8245 14.3956 17.2671 14.8421C17.4824 15.0592 17.6025 15.1976 17.6612 15.353C17.7495 15.587 17.6663 15.7704 17.6121 15.8932C17.603 15.9135 17.5929 15.9359 17.5824 15.9607C17.479 16.2056 17.3534 16.4405 17.207 16.6623C16.946 17.0527 16.6816 17.3549 16.2402 17.5604C16.0135 17.6676 15.7654 17.7219 15.5147 17.7193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.cbffec968803ae7a6dc174c45f1f8f73.svg";
export { ForwardRef as ReactComponent };